import styled from 'styled-components';

import { colorsPalettes, setFontVariant } from '@similarweb/styles';

export const StyledSalesforceActivityAccountFilter = styled.div`
  width: 180px;
  margin-left: auto;
`;

export const StyledSalesforceActivitySingleAccount = styled.div`
  ${setFontVariant('listItem3', colorsPalettes.carbon[400])};
  padding: 8px 0;
  margin-left: auto;
  text-transform: capitalize;
  max-width: 200px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;
